export default {
    init() {
      // JavaScript to be fired on the course update loading page
  
    },
    finalize(){
        const register_id = $('#registerId').data('registerId');
        if (register_id){
            $.ajax({
                type: "POST",
                url: ajaxdta.ajaxurl + "?action=update_data_retrieve_redirect_url",
                data: {
                    registerId : register_id,
                },
                data_type: 'JSON',
                    success: function (data, status, xhr) {
                        const parsed_data = JSON.parse(data);
                        const redirect_url = decodeURIComponent(parsed_data.url);
                        window.location.href = redirect_url;
                    }
            });
        }
    }
  };


// WEBPACK FOOTER //
// ./scripts/routes/course-update-page.js